import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize } from 'brand-guidelines/utils/screenSizeUtils';
import { SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

export const BaseBodyText = styled.p`
  ${TYPOGRAPHY.OPEN_SANS.base}
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: ${BRAND_COLORS.darkGray};
`;

export const BaseHeaderText = styled.h1`
  ${TYPOGRAPHY.CIRCULAR.bold}
  margin: 0;
  font-size: 32px;
  line-height: 36px;
  color: ${BRAND_COLORS.black};

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      font-size: 28px;
      line-height: 32px;
    `,
  )}
`;

export const TermsDisclaimer = styled(BaseBodyText).attrs({ as: 'p' })`
  font-size: 12px;
  line-height: 20px;
  text-align: center;
`;
